import { QUESTIONNAIRE_KEYS } from 'modules/assistant/constants/questionnaires';

export default {
  user: {
    current: null,
  },
  plan: {
    progress: {} as PlanProgressDTO,
  },
  documents: {
    list: {} as AssetsDTO,
  },
  modal: {
    name: null,
    props: {} as ModalProps,
  },
  contacts: {
    list: [] as ContactDTO[],
    backup: [] as ContactDTO[],
  },
  heirs: {
    list: [] as ContactDTO[],
  },
  overviewContact: {
    item: null as null | ContactDTO,
  },
  contactOf: {
    list: [] as ContactOfDTO[],
  },
  common: {
    asyncAction: null,
    pathname: '/',
  },
  loading: {
    value: false,
  },
  layout: {
    assetEdit: {
      currentAsset: {} as AssetsDTO,
      isShowEditForm: false,
    },
    isShowSubscriptionWidget: true,
  },
  questionnaires: {
    [QUESTIONNAIRE_KEYS.PATIENT_DECREE]: {},
    [QUESTIONNAIRE_KEYS.HEALTH_CARE_PROXY]: {},
    [QUESTIONNAIRE_KEYS.WILL_GENERATOR]: {},
    [QUESTIONNAIRE_KEYS.ORGAN_DONOR_CARD]: {},
    [QUESTIONNAIRE_KEYS.INITIAL_ASSESSMENT]: {},
    [QUESTIONNAIRE_KEYS.PET_WATCHING_AGREEMENT]: {},
    [QUESTIONNAIRE_KEYS.CUSTODY_ORDER]: {},
    [QUESTIONNAIRE_KEYS.FUNERAL_PROVISION]: {},
  },
  assistant: {
    progress: {} as AssistantProgressDTO,
  },
  recommendations: {} as RecommendationsDTO,
  temporaryField: { value: null },
  assets: {} as AssetsDTO,
  assetTypes: {} as AssetTypesDTO,
  assetTemplates: {} as AssetTypesDTO,
  immediateAssets: {} as immediateAssetsDTO,
  notifications: {
    isPanelOpen: false,
    notifications: [] as NotificationDTO[],
  },
  nextSteps: {
    list: [] as NextStep[],
  },
  providers: {
    current: {} as ProvidersDTO,
  },

  assetSearch: {} as AssetsSearchDTO,

  keyHolders: {
    value: [] as KeyHolder[],
  },
};
